module.exports = __webpack_public_path__ + "img/booking_list_icon.506da756.svg";